if (!customElements.get('quantity-picker')) {
    class QuantityPicker extends HTMLElement {
        static observedAttributes = ["quantity", "loading", "disabled"];

        constructor() {
            super();

            this.elInput = null;
            this.elUpdate = null;

            this.currentQuantity = Number(this.getAttribute('quantity'));
            this.min = this.getAttribute('min') ? Number(this.getAttribute('min')) : 0;
            this.max = this.getAttribute('max') ? Number(this.getAttribute('max')) : 1000;
            this.disabled = this.getAttribute('disabled') ? this.getAttribute('disabled') == 'true' : false;

            this.inputName = this.getAttribute('data-name');
            this.inputId = this.getAttribute('data-id');
            this.inputTitle = this.getAttribute('data-title');

            this.render();
        }

        render() {
            this.innerHTML = `
                <button 
                    type="button"
                    aria-label="Decrease quantity of ${this.inputTitle}"
                    data-update="decrease"
                    ${this.disabled || this.currentQuantity == this.min ? 'disabled' : ''}
                ></button>
                <span role="presentation">
                    ${this.currentQuantity}
                </span>
                <input 
                    type="number"
                    id="${this.inputId}"
                    name="${this.inputName}"
                    value="${this.currentQuantity}"
                    min="${this.min}"
                    max="${this.max}"
                    aria-label="Quantity of ${this.inputTitle}"
                    ${this.disabled ? 'disabled' : ''}
                    class="visually-hidden"
                    data-quantity-input
                />
                <button 
                    type="button"
                    aria-label="Increase quantity of ${this.inputTitle}"
                    data-update="increase"
                    ${this.disabled || this.currentQuantity == this.max ? 'disabled' : ''}
                ></button>
            `;

            this.elInput = this.querySelector('[data-quantity-input]');
            this.elUpdate = this.querySelectorAll('[data-update]');

            this.elUpdate.forEach(el =>
                el.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    const shouldIncrease = el.getAttribute('data-update') == 'increase';
                    const newQuantity = shouldIncrease ? +this.currentQuantity + 1 : +this.currentQuantity - 1;
                    this.setAttribute('quantity', newQuantity);
                })
            )
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (name == 'quantity') {
                this.currentQuantity = Number(newValue);
                this.render();
                this.elInput.dispatchEvent(new Event('change', { bubbles: true }));
            } else if (name == 'loading') {
                const shouldDisable = newValue == "true";
                shouldDisable ? this.classList.add('loading') : this.classList.remove('loading');
                this.elUpdate.forEach(el => {
                    el.disabled = shouldDisable;
                })
            } else if (name == 'disabled') {
                this.disabled = newValue == "true";
                this.render();
            }
        }
    }

    customElements.define('quantity-picker', QuantityPicker);
}
